<template>
  <v-container fill-width fill-height class="d-flex align-start">
    <v-row style="padding-top: 50px;">
      <v-col cols="12" justify="center" align="center">
        <v-progress-circular
          indeterminate
          color="success"
        ></v-progress-circular>
      </v-col>
      <v-col cols="12" >    
        <h4 class="text-center align-self-center"> Carregando componente. Aguarde... </h4>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
    name: 'loading',
    data () {
      return {

      }
    }
  
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/Comum/_loading.vue